import React, { useEffect, useRef, useState } from 'react'

import DataTableList from '../../components/DataTable/DataTableList'
import SingleSuspendPopup from '../../components/SingleSuspendPopup';
import MultipleSuspendPopup from '../../components/MultipleSuspendPopup';
import NoResults from '../../components/Noresults';
import Dropdown from '../../components/Dropdown/Dropdown';
import { useStaticDataStore } from '../../stores/staticData';
import { dateFormat, formattedDate } from '../../utils/formattedDate';

import search from '../../assets/images/search.svg';
import avatar from '../../assets/images/Avatar.png'
import report from '../../assets/images/report.png'
import { USER_REPORT_TYPE } from '../../constants/common';

const OpenReports = (props) => {
    const { setEditReport, reportList, setSelectedReport, totalPage, setCurrentPage, currentPage, searchQuery, setSearchQuery, selectedRows, setSelectedRows, isAllSelected, setIsAllSelected, toggleSelect, isLoading, setIsLoadingData, isLoadingData, setReportSuspendPopup, setMultipleReportSuspendPopup, userTypeSelectRef, reasonRef, LazyImage, setReason, filterReport, setFilterReport, setErrorMessage } = props

    const { data: staticData } = useStaticDataStore();

    let reportReason = [];
    if (staticData?.reportForFounders?.length) {
        reportReason = staticData?.reportForFounders;
    }

    const userType = USER_REPORT_TYPE;

    const [userTypeSelect, setUserTypeSelect] = useState(false);
    const [reasonSelect, setReasonSelect] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);

    useEffect(() => {
        if (reportList?.length > 0) {
            calculateColumnWidths().then(() => {
                setTimeout(() => {
                    setIsLoadingData(false);
                }, 1000);
            });
        }
    }, [reportList]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(reportList?.map((row) => row?.id));
        }
        setIsAllSelected(!isAllSelected);
    };

    const handleDelete = async () => {
        if (selectedRows?.length === 1) {
            const selected = reportList?.find((row) => row?.id === selectedRows[0]);
            if (selected) {
                setSelectedReport(selected);
            }
            setReportSuspendPopup(true);
        }

        if (selectedRows?.length > 1) {
            setMultipleReportSuspendPopup(true);
        }
    };

    const calculateColumnWidths = () => {
        return new Promise((resolve) => {
            const tempWidths = reportList?.reduce((acc, row) => {
                Object.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = 0;

                    if (key === 'reasons') {
                        const categories = row[key];

                        if (categories?.length > 1) {
                            let tempCatLength = 0;

                            for (let i = 0; i < 1; i++) {
                                tempCatLength = tempCatLength + categories[i]?.length;
                            }

                            maxContentLength = Math?.max(tempCatLength, title?.length);

                        } else {
                            if (categories?.length == 0) {
                                maxContentLength = Math?.max(dataValue?.length + 5);
                            } else {
                                maxContentLength = Math?.max(dataValue?.length + 3, title?.length);
                            }
                        }

                    } else {
                        maxContentLength = Math?.max(dataValue?.length, title?.length);
                    }

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            if (tempWidths !== undefined) {
                const widthMap = Object.keys(tempWidths)?.reduce((acc, key) => {

                    if (key === 'reasons') {
                        reportList?.forEach((row) => {
                            const categoryWidth = tempWidths[key] * 10 + 40;
                            acc[key] = `${categoryWidth}px`;
                        });
                    } else {
                        acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    }
                    return acc;
                }, {});

                setColumnWidths(widthMap);
            }
            resolve();
        });

    };
    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '24px',
                color: '#666666'
            },
        },
    };

    const columns = [
        {
            name: 'Report number',
            selector: (row) => row?.id,
            cell: (row) => {
                return <span className="report-name">
                    #{row?.id || 'NO NAME'}
                </span>
            },
            sortable: true,
            minWidth: "230px",
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 500, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Reported',
            selector: (row) => row?.reportedName,
            cell: (row) => {
                return <div className="vc-content vcTable" onClick={() => { setEditReport(true); setSelectedReport(row); }}>
                    <LazyImage
                        src={row?.reportedProfileImg || avatar}
                        alt="Reported user"
                    />
                    <div className="vc-brief">
                        <span className="vc-name">
                            {row?.reportedName || 'NO NAME'}
                        </span>
                    </div>
                </div>
            },
            sortable: true,
            minWidth: columnWidths['reportedName'] && `${parseInt(columnWidths['reportedName']) + 115}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Reported by',
            selector: (row) => row?.reportByName,
            cell: (row) => {
                return <div className="report-content vcTable">
                    <LazyImage
                        src={row?.reportByProfileImg || avatar}
                        alt="Report by user"
                    />
                    <div className="vc-brief">
                        <span className="vc-name">
                            {row?.reportByName || 'NO NAME'}
                        </span>
                    </div>
                </div>
            },
            sortable: true,
            minWidth: columnWidths['reportByName'] && `${parseInt(columnWidths['reportByName']) + 110}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Reason',
            cell: (row) => {
                var reasons = row?.reasons?.slice(0, 1);
                var reasonFull = row?.reasons?.slice(1);
                const getReasonValue = (itemKey) => {
                    const found = reportReason?.find(rsn => rsn?.key === itemKey);
                    return found ? found?.value : itemKey;
                };
                return (<div className='industriesCategory'>
                    <div>
                        {reasons?.map((item, index) => (
                            <span key={index}>{getReasonValue(item)}</span>
                        ))}
                        {row?.reasons?.length > 1 && (
                            <div className="industriesList">
                                <span>+{row?.reasons?.length - 1}</span>
                                <div className="industriesTooltip">
                                    {reasonFull?.map((item, idx) => (
                                        <p key={idx}>{getReasonValue(item)}</p>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>)
            },
            paddingLeft: 0,
            width: columnWidths['reasons'] && `${parseInt(columnWidths['reasons']) + 50}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", width: columnWidths['reasons'] && `${parseInt(columnWidths['reasons']) - 20}px`, lineHeight: '20px' },
        },
        {
            name: 'Date reported',
            selector: (row) => row?.dateOfReported,
            cell: (row) => {
                return <p>{formattedDate(row?.dateOfReported)}</p>
            },
            sortable: true,
            minWidth: columnWidths['dateOfReported'] && `${parseInt(columnWidths['dateOfReported']) - 10}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Actions',
            cell: (row) => {
                return (
                    <>
                        <div className='table-actions'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { setEditReport(true); setSelectedReport(row); }}>
                                <path d="M2.15703 13.583C2.19149 13.2729 2.20872 13.1179 2.25564 12.9729C2.29726 12.8444 2.35607 12.722 2.43048 12.6092C2.51434 12.482 2.62466 12.3717 2.8453 12.151L12.75 2.24632C13.5784 1.41789 14.9216 1.41789 15.75 2.24632C16.5784 3.07475 16.5784 4.41789 15.75 5.24632L5.84529 15.151C5.62466 15.3717 5.51434 15.482 5.38717 15.5658C5.27434 15.6402 5.15197 15.6991 5.02338 15.7407C4.87845 15.7876 4.72339 15.8048 4.41328 15.8393L1.875 16.1213L2.15703 13.583Z" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { setReportSuspendPopup(true); setSelectedReport(row); setReason(''); setErrorMessage(''); }}>
                                <path d="M12 4.5V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V4.5M7.5 8.625V12.375M10.5 8.625V12.375M2.25 4.5H15.75M14.25 4.5V12.9C14.25 14.1601 14.25 14.7902 14.0048 15.2715C13.789 15.6948 13.4448 16.039 13.0215 16.2548C12.5402 16.5 11.9101 16.5 10.65 16.5H7.35C6.08988 16.5 5.45982 16.5 4.97852 16.2548C4.55516 16.039 4.21095 15.6948 3.99524 15.2715C3.75 14.7902 3.75 14.1601 3.75 12.9V4.5" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </>
                )
            },
            justifyContent: 'flex-end',
            allowOverflow: true,
            button: true,
            minWidth: "55px",
            paddingRight: '16px',
            width: '70px',
            style: { textAlign: 'right', minWidth: '70px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" },
        },
    ]

    return (
        <div className='active-reports'>
            <div className='active-report-top'>
                <div className='pagesSearch twoItemWrap'>
                    <div className="pageSearchInput">
                        <input type="text" name="pages_search" className="inputFields" id="pages_search" placeholder={'Search open reports...'} autoComplete="off" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                        <img src={search} alt="Search" />
                    </div>

                    <Dropdown
                        ref={userTypeSelectRef}
                        selectedDropdown={userTypeSelect}
                        setSelectedDropdown={setUserTypeSelect}
                        items={userType}
                        setSelectedValue={(newValue) =>
                            setFilterReport((prev) => ({
                                ...prev,
                                userType: newValue
                            }))
                        }
                        selectedValue={filterReport?.userType ?? []}
                        name={"User type"}
                    />

                    <Dropdown
                        ref={reasonRef}
                        selectedDropdown={reasonSelect}
                        setSelectedDropdown={setReasonSelect}
                        items={reportReason}
                        setSelectedValue={(newValue) =>
                            setFilterReport((prev) => ({
                                ...prev,
                                reasons: newValue
                            }))
                        }
                        selectedValue={filterReport?.reasons ?? []}
                        name={"Reason"}
                    />

                </div>
                {
                    <div className='new-report'>
                        {selectedRows?.length > 0 &&
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { handleDelete(); setReason(''); }}>
                                <path d="M12 4.5V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V4.5M7.5 8.625V12.375M10.5 8.625V12.375M2.25 4.5H15.75M14.25 4.5V12.9C14.25 14.1601 14.25 14.7902 14.0048 15.2715C13.789 15.6948 13.4448 16.039 13.0215 16.2548C12.5402 16.5 11.9101 16.5 10.65 16.5H7.35C6.08988 16.5 5.45982 16.5 4.97852 16.2548C4.55516 16.039 4.21095 15.6948 3.99524 15.2715C3.75 14.7902 3.75 14.1601 3.75 12.9V4.5" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        }
                    </div>
                }
            </div>
            <div className='table-pagination-wrapper report-table-list'>
                <div
                    className={`pagesTable dataTable-list ${isLoadingData ? 'loading-list' : ''
                        }`}
                >
                    <DataTableList
                        data={reportList}
                        columns={columns}
                        customStyles={customStyles}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        currentPage={currentPage}
                        selectableRowsComponent="input"
                        selectableRows={false}
                        selectAllRows={isAllSelected}
                        onSelectAllChange={handleMasterCheckboxChange}
                        clearSelectedRows={toggleSelect}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows?.map((row) => row?.id);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds?.length === reportList?.length);
                        }}
                        progressPending={isLoading}
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                        noDataComponent={<NoResults title='No open reports yet' description="Looks like there aren’t any open reports to show right now. Keep an eye out - we’ll surface anything that needs your attention!" image={report} />}
                    />
                </div>
            </div>
        </div>
    )
}

export default OpenReports
